import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--gray);
  gap: 1rem;
  margin-bottom: 1.4rem;

  strong {
    color: var(--primary_color);
  }
`;
